import { createContext as o, useContext as e } from "react";
const t = {
  isOpen: !1,
  openDropdown: () => {
  },
  closeDropdown: () => {
  },
  triggerRef: { current: null }
}, n = o(t), p = () => e(n);
export {
  n as DropdownContext,
  p as useDropdownContext
};
